export default __webpack_public_path__ + "static/media/pictogramBeaconMoneyIn64.484e2635.svg";